import React, { useEffect } from 'react';

import styled from 'styled-components';

import { sendBrazeEvent } from 'analytics/braze';

import CalculatorForLanding from 'components/calculator/CalculatorForLanding';
import { PromoIcon } from 'components/no-auth/common/promo-icon/PromoIcon';

import { BR_NEW_TRANSFER_BUTTON_CLICKED, BR_SEND_MONEY_FROM_DEFAULT, BR_SEND_MONEY_TO_DEFAULT } from 'constants/braze/brazeEvents';
import { BR_DEFAULT_AMOUNT, BR_DEFAULT_COUNTRY, BR_DEFAULT_CURRENCY, BR_LANGUAGE } from 'constants/braze/brazeParams';
import { REQUEST_FORM_NAME, SEND_FORM_NAME } from 'constants/formName';
import { LOGIN } from 'constants/UrlConstants';

import { useApp, useCalculator, useLanguage, usePageMessages } from 'hooks/selectors';

import Illustration from './Illustration';

export const CalculatorTempContainer = styled.div`
    @media screen and (min-width: 1352px) {
        width: 46.4286%;
        position: absolute;
        right: 0;
        top: 0;
    }
`;

const CalculatorSection = ({ features, isRequest, localeDependentURI }) => {
    const {
        promoSendHeadline,
        promoSendAnnotation,
        promoSendDelivery,
        promoSendSecurity,
        getStarted,
        feeLandingInfo,
        feeLandingReduceFee,
        promoAdditionalInfo,
    } = usePageMessages();
    const { countryMenu = {}, commission } = useCalculator();
    const { isMobileBrowser } = useApp();
    const { lang } = useLanguage();

    const countryToCode = countryMenu?.countryTo?.code;

    useEffect(() => {
        if (commission) {
            const {
                from: amountFrom,
                to: amountTo,
                restrictionFrom: { ccyIso: ccyIsoFrom },
                restrictionTo: { ccyIso: ccyIsoTo },
            } = commission;
            const { countryFrom, countryTo } = countryMenu;
            sendBrazeEvent(BR_SEND_MONEY_FROM_DEFAULT, {
                [BR_LANGUAGE]: lang,
                [BR_DEFAULT_CURRENCY]: ccyIsoFrom,
                [BR_DEFAULT_COUNTRY]: countryFrom?.code ?? '',
                [BR_DEFAULT_AMOUNT]: amountFrom,
            });

            sendBrazeEvent(BR_SEND_MONEY_TO_DEFAULT, {
                [BR_LANGUAGE]: lang,
                [BR_DEFAULT_CURRENCY]: ccyIsoTo,
                [BR_DEFAULT_COUNTRY]: countryTo?.code ?? '',
                [BR_DEFAULT_AMOUNT]: amountTo,
            });
        }
    }, [commission]);

    const getPromotionUrlBlock = (features, feeLandingInfo, promoAdditionalInfo) => {
        if (promoAdditionalInfo && promoAdditionalInfo !== '') {
            return <p className="smallcopy" dangerouslySetInnerHTML={{ __html: promoAdditionalInfo }} />;
        } else {
            return '';
        }
    };

    return (
        <>
            <div className={`section-calculator image-country_${countryToCode}`} id="calculator">
                <div className="box-1280">
                    <div className="inner-content">
                        <div className="inner-inner-content">
                            <div id="component-headline" className="lead-text  no-spinner">
                                <h1 className="title0">{promoSendHeadline}</h1>
                                <p className="title3" dangerouslySetInnerHTML={{ __html: promoSendAnnotation }} />

                                {getPromotionUrlBlock(features, feeLandingInfo, promoAdditionalInfo)}
                            </div>
                            <CalculatorTempContainer>
                                <CalculatorForLanding
                                    formName={isRequest ? REQUEST_FORM_NAME : SEND_FORM_NAME}
                                    isSend={!isRequest}
                                    localeDependentURI={localeDependentURI}
                                    bntCaption={getStarted}
                                    href={`${LOGIN}?from_page=${isRequest ? 'request' : 'send'}`}
                                    onClick={() => {
                                        sendBrazeEvent(!isRequest ? BR_NEW_TRANSFER_BUTTON_CLICKED : null);
                                    }}
                                    dataTestid="calculator-block-btn-float"
                                />
                            </CalculatorTempContainer>
                            {!isMobileBrowser && (
                                <div className="no-spinner" id="landing-block-features">
                                    <ul className="header-features smallcopy">
                                        <li>
                                            <PromoIcon name="check-rounded-thin" color="primary" />
                                            <p className="value">{promoSendDelivery}</p>
                                        </li>
                                        <li>
                                            <PromoIcon name="heart" color="primary" />
                                            <p className="value">{promoSendSecurity}</p>
                                        </li>
                                        <li>
                                            <PromoIcon name="lifebuoy-thin" color="primary" />
                                            <p className="value">{feeLandingReduceFee}</p>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {!isMobileBrowser && <Illustration countryToCode={countryToCode} promoSendHeadline={promoSendHeadline} />}
        </>
    );
};

export default CalculatorSection;
